import React from 'react';
import { LocalizationFlags, SportSliderDict } from '@draftkings/sportsbook-common-contracts';

export type AppContextProps = {
    dictionary: SportSliderDict;
    locale?: string;
    localizationFlags?: LocalizationFlags;
};

export const AppContext = React.createContext<AppContextProps | undefined>(undefined);
